module.exports = __webpack_public_path__ + "img/icon.911d9aec.png";